// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
if (!(global as any)._babelPolyfill) {
	require('babel-polyfill');
}

require('./../Sass/base.scss');
import * as helper from './../../../../../VX/View/Assets/Js/helper';
import {initImprint} from "../../../Assets/JS/imprint_la";

helper.onDocumentLoaded(() => {
	initImprint(helper.$('#impressumlink'), helper.$('#datenschutzlink'));

	const wrapper = helper.$('#wrapper');
	const questions = helper.$('.profile-bottom-right');
	const buttons = Array.from(helper.$('.step-btn'));
	const lastButton = buttons.pop();
	const url1 = helper.getData(wrapper, 'url1');
	const url2 = helper.getData(wrapper, 'url2');
	const ab1 = parseInt(helper.getData(wrapper, 'ab1'), 10);
	const age = parseInt(helper.getData(wrapper, 'age'), 10);

	const messages = [
		{image: 'user_08.jpg', name: 'Chaosmaus', text: 'Neues Foto hinzugefügt'},
		{image: 'user_09.jpg', name: 'Luisa', text: 'hat ein neues Video hochgeladen'},
		{image: 'user_10.jpg', name: 'Jessy', text: 'Rollig sein'},
		{image: 'user_11.jpg', name: 'Ninifee', text: 'Neues Foto hinzugefügt'},
		{image: 'user_12.jpg', name: 'Purzel91', text: 'hat ein neues Video hochgeladen'},
	]

	let index = 0;
	function newMessages() {
		if (messages.length === 0) {
			return
		} else {
			const currentMessage = messages.shift();
			const desktopHtml = helper.stringToHtml(`<div class="message hidden">
								<img src="/DynBanner/PreUmfrage3/img/${age}/${currentMessage.image}" alt="" class="message-img">
								<div class="message-content">
								 <div class="message-content-name">${currentMessage.name}</div>
								 <div class="message-content-text">${currentMessage.text}</div>
								</div>
								<div class="message-timestamp">gerade eben</div>
							   </div>`);

			const mobileHtml = helper.stringToHtml(`<div class="mobile-message">
														  <img src="/DynBanner/PreUmfrage3/img/${age}/${currentMessage.image}" alt="" class="mobile-message-img" />
														  <div class="mobile-message-content">
															<div class="mobile-message-content-name">${currentMessage.name}</div>
															<div class="mobile-message-content-status">${currentMessage.text}</div>
															<div class="mobile-message-content-time">gerade eben</div>
														  </div>
														</div>`)

			const firstMessageElement = document.querySelector('.messages > .message');
			firstMessageElement.parentNode.insertBefore(desktopHtml, firstMessageElement)
			document.querySelector('.profile-header').appendChild(mobileHtml);

			setTimeout(() => {
				helper.removeClass(document.querySelector('.messages .message.hidden'), 'hidden');
				let unhidden = document.querySelectorAll('.messages .message:not(.hidden)');
				helper.addClass(unhidden[unhidden.length - 1], 'hidden');
			}, 100);

			setTimeout(newMessages, 12000);
		}
	}

	if (ab1 === 1) {
		setTimeout(newMessages, 4000);
	}

	function advance() {
		helper.hide(questions[index]);
		index++;
		helper.removeClass(questions[index], 'd-none');
	}

	buttons.forEach((button) => {
		helper.addClickListener(button, advance)
	})

	helper.addClickListener(lastButton, () => {
		window.open(url1);
		window.location.href = url2;
	})
});
